"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorInitQuery = void 0;
/* eslint-disable unicorn/filename-case */
/* eslint-enable unicorn/filename-case */
const ActorInitQueryBase_1 = require("./ActorInitQueryBase");
/* istanbul ignore next */
if (typeof process === 'undefined') {
    // Polyfills process.nextTick for readable-stream
    global.process = require('process'); // eslint-disable-line import/no-nodejs-modules
}
class ActorInitQuery extends ActorInitQueryBase_1.ActorInitQueryBase {
}
exports.ActorInitQuery = ActorInitQuery;
//# sourceMappingURL=ActorInitQuery-browser.js.map